import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";

import About from "@/components/About";
import Blog from "@/components/Blog";
import BlogDetails from "@/components/BlogDetails";
import Contact from "@/components/Contact";
import Homepage from "@/components/Homepage";
import Pricing from "@/components/Pricing";
import Privacy from "@/components/Privacy";
import Projects from "@/components/Projects";
import Services from "@/components/Services";

Vue.use(VueRouter);
Vue.use(Meta);

const router = new VueRouter({
	mode: "history",
	routes: [
		{ name: "home", path: "/:lang", component: Homepage },
		{ name: "about", path: "/:lang/about-softcare", component: About },
		{ name: "blog", path: "/:lang/blog", component: Blog },
		{ path: "/:lang/blog/:slug", component: BlogDetails },
		{ name: "contact", path: "/:lang/contact", component: Contact },
		{ name: "privacy", path: "/:lang/privacy", component: Privacy },
		{ name: "pricing", path: "/:lang/pricing", component: Pricing },
		{ name: "projects", path: "/:lang/projects", component: Projects },
		{ name: "services", path: "/:lang/services", component: Services },
		{ path: "*", component: Homepage }
	]
});

const self = this;
router.beforeEach(function(to, from, next) {
	if (to.params.lang) {
		next();
	} else {
		next("/" + self.a.app.$options.i18n.locale);
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js